// import $ from 'jquery';
// import { headerTippyInstances } from './instance-builders/shared-objects';

export default class BaseAction {

	/**
	 * @param {JQuery} $container
	 */
	async init($container) {}
}
